import { Card } from "./ui/Card";
import { useAuth } from "context/AuthContext";
import { formatCrontabHumanReadable } from "utils/formatCrontab";

interface TaskSummaryProps {
  title: string;
  crontab: string | null;
}

export function TaskSummary({ title, crontab }: TaskSummaryProps) {
  const { lang } = useAuth();
  const locale = lang === "es" ? "es" : "en";
  const hasSchedule = Boolean(crontab);

  const scheduleLine = hasSchedule
    ? locale === "es"
      ? `Agendada: ${formatCrontabHumanReadable(crontab!, locale)}`
      : `Scheduled: ${formatCrontabHumanReadable(crontab!, locale)}`
    : locale === "es"
      ? "Sin periodicidad · Desactivada"
      : "No schedule · Disabled";

  return (
    <Card>
      <h2 className="sr-only lg:not-sr-only mb-0 truncate text-base font-semibold text-gray-900 lg:mb-1">
        {title}
      </h2>
      <p className="text-xs lg:text-sm text-gray-600">{scheduleLine}</p>
    </Card>
  );
}
